<div class="modal-header">
  <h4 [innerText]="title" class="modal-title h5" translate></h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <p class="mb-0"><span [innerHTML]="body"></span></p>
</div>

<scitis-modal-footer (cancelButtonPressed)="onCancel($event)"
                     (okButtonPressed)="onOk($event)"
                     [cancelButtonText]="cancelButtonText"
                     [disableOkButton]="disableOkButton"
                     [okButtonText]="okButtonText">

</scitis-modal-footer>